import React from "react";
import { useReveal } from "../hooks/useReveal";

const FeatureItem = ({ icon, title, text, index }) => {
  const [ref, visible] = useReveal();
  const delayClass = `reveal-delay-${Math.min(index + 1, 6)}`;
  return (
    <div
      ref={ref}
      className={`col-xs-6 col-md-3 reveal ${delayClass} ${visible ? "is-visible" : ""}`}
    >
      <i className={icon}></i>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
};

export const Features = (props) => {
  const [titleRef, titleVisible] = useReveal();
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div
          ref={titleRef}
          className={`col-md-10 col-md-offset-1 section-title reveal ${titleVisible ? "is-visible" : ""}`}
        >
          <h2>What We Do</h2>
          <p>
            End-to-end AI consulting — from strategy to deployed systems — delivered by senior engineers.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <FeatureItem key={`${d.title}-${i}`} index={i} {...d} />
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
